import { v4 as uuidv4 } from 'uuid'
import { WebStorage } from './storage'

export function createOrExtendUserId(projectId: string): void {
    const existingUid = WebStorage.getUserId(projectId)
    if (!existingUid) {
        const userId = uuidv4()
        WebStorage.setUserId(projectId, userId)
    } else {
        WebStorage.setUserId(projectId, existingUid)
    }
}
